import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>Learn more about <a href="#">Job-Fax</a> here.</p>
    </div>
  );
}

export default Footer;
